import React from "react";
import gql from "graphql-tag";
import { Box, Flex } from "@atoms";
import { constants } from "@services";
import { FundsPageEarningsChart } from "../FundsPageEarningsChart";
import { FundsPageEarningsLegend } from "../FundsPageEarningsLegend";
import { FundsPageEarningsFundraisersList } from "../FundsPageEarningsFundraisersList";
import { FundsPageEarningsGroupsListAnonymous } from "../FundsPageEarningsGroupsListAnonymous";
import { FundsPageEarningsGroupsList } from "../FundsPageEarningsGroupsList";
import { FundsPageEarningsFragment } from "./__generated__/FundsPageEarningsFragment";

// == Types ================================================================

interface IProps {
  campaign: FundsPageEarningsFragment;
  hasNextPage: boolean;
}

// == Constants ============================================================

FundsPageEarnings.fragments = gql`
  fragment FundsPageEarningsFragment on Campaign {
    id
    privacyLevel
    isViewerOwner @include(if: $hasCurrentUser)
    noGroupFundraisers {
      id
      name
    }
    groups {
      id
      name
    }
    ...FundsPageEarningsChartFragment
    ...FundsPageEarningsLegendFragment
    ...FundsPageEarningsGroupsListFragment
    ...FundsPageEarningsGroupsListAnonymousFragment
    ...FundsPageEarningsFundraisersListViewerFundraiserFragment
  }
  ${FundsPageEarningsChart.fragments}
  ${FundsPageEarningsLegend.fragments}
  ${FundsPageEarningsGroupsList.fragments}
  ${FundsPageEarningsGroupsListAnonymous.fragments}
  ${FundsPageEarningsFundraisersList.fragments.viewerFundraiser}
  ${FundsPageEarningsFundraisersList.fragments.fundraisers}
`;

// == Component ============================================================

export default function FundsPageEarnings({ campaign }: IProps) {
  const { privacyLevel, groups, isViewerOwner } = campaign;
  const {
    PRIVACY_LEVEL_TYPES: { ANONYMOUS },
  } = constants;
  const isGroups = Object.keys(groups).length > 0;
  const isCampaignAnonymous = privacyLevel === ANONYMOUS;

  const renderGroups = () => {
    if (isGroups && isCampaignAnonymous && !isViewerOwner)
      return <FundsPageEarningsGroupsListAnonymous campaign={campaign} />;
    return <FundsPageEarningsGroupsList campaign={campaign} />;
  };

  return (
    <Box>
      <Flex
        alignItems="center"
        bg="lightBlueBg"
        flexDirection="column"
        justifyContent="space-evenly"
      >
        <Flex alignItems="center" flexDirection="row" justifyContent="space-between">
          <FundsPageEarningsChart campaign={campaign} />
          <FundsPageEarningsLegend campaign={campaign} />
        </Flex>
      </Flex>
      <Flex alignItems="center" flexDirection="column" justifyContent="flex-start">
        {renderGroups()}
      </Flex>
    </Box>
  );
}

// == Styles ===============================================================
